// زیرسیستم‌های قابل خریداری --------------------------------------------------
// تنها مرجع نگاشت بین شناسه زیرسیستم‌های سرور (خروجی
// base/api/v1/DropDown/CompanySubSystems) و ماژول‌های برنامه.
//
// هر زیرسیستم با یکی از این دو روش به برنامه وصل می‌شود:
//   module: نام مسیر ریشه ماژول در روتر (مثل "PWHRS" یا "PACNT")
//   devKey: کلید ماژول در config/underDevelopmentModules.js
//
// زیرسیستم‌هایی که هنوز ماژول متناظری در برنامه ندارند (باشگاه مشتریان،
// برنامه‌ریزی و مدیریت تولید، خدمات و پشتیبانی) در این لیست نیستند؛ و
// ماژول‌هایی که زیرسیستم متناظر ندارند (PCRM، توزیع، تجارت الکترونیک،
// اتوماسیون اداری، R&D، ریسک و نوآوری) هرگز قفل نمی‌شوند.

import {
  findUnderDevelopmentModule,
  devRouteName,
} from "@/config/underDevelopmentModules.js";

// اطلاعات تماس واحد فروش پارسینا
export const parsinaContact = {
  website: "https://www.parsinaco.com/",
  support: "https://www.parsinaco.com/support",
  phones: [
    { number: "02533553325", label: "تلفن ثابت واحد فروش" },
    { number: "09307086900", label: "همراه واحد فروش" },
  ],
};

// ماژول‌هایی که هیچ‌وقت نباید قفل شوند.
// PBASE عمداً در این لیست است: کاربر بعد از ورود به /PBASE/Dashboard می‌رود و
// قفل شدن آن یعنی نبود دسترسی به داشبورد، پروفایل و تنظیمات پایه.
const neverLockedModules = ["PBASE", "PPARSINA", "PDEV"];

const subSystems = [
  // ------------------------------------------------ مدیریت مالی
  {
    id: 10,
    title: "مدیریت سیستم",
    module: "PBASE",
    icon: "mdi-cog-outline",
    description:
      "مدیریت کاربران و نقش‌ها، سطوح دسترسی، تعریف شعب و سال مالی و اطلاعات پایه مشترک میان همه ماژول‌ها.",
    features: [
      "تعریف کاربران، نقش‌ها و سطوح دسترسی",
      "مدیریت شعب و سال‌های مالی",
      "اطلاعات پایه مشترک سیستم",
      "پایش نشست‌های فعال کاربران",
    ],
  },
  {
    id: 11,
    title: "حسابداری",
    module: "PACNT",
    icon: "mdi-book-open-page-variant-outline",
    description:
      "کدینگ حساب‌ها، صدور و گردش اسناد حسابداری، تفصیلی شناور و گزارش‌های مالی استاندارد.",
    features: [
      "کدینگ حساب‌ها و تفصیلی شناور",
      "صدور، ویرایش و گردش تأیید سند",
      "دفاتر روزنامه، کل و معین",
      "تراز آزمایشی و گزارش‌های مالی",
    ],
  },
  {
    id: 12,
    title: "خزانه",
    module: "PBANK",
    icon: "mdi-cash-multiple",
    description:
      "مدیریت دریافت و پرداخت، چک‌ها، صندوق و حساب‌های بانکی با صدور خودکار سند حسابداری.",
    features: [
      "ثبت دریافت و پرداخت",
      "مدیریت چک‌های دریافتی و پرداختی",
      "صندوق و حساب‌های بانکی",
      "اتصال خودکار به حسابداری",
    ],
  },
  { id: 13, title: "تنخواه", devKey: "pettyCash" },
  { id: 14, title: "اموال و دارایی‌های ثابت", devKey: "fixedAssets" },
  { id: 15, title: "بودجه", devKey: "pbdgt" },
  { id: 16, title: "تسهیلات و اعتبارات", devKey: "facilities" },
  {
    id: 17,
    title: "سامانه مؤدیان",
    module: "PTAX",
    icon: "mdi-receipt-text-outline",
    description:
      "یکپارچگی با سامانه مودیان سازمان امور مالیاتی جهت ارسال صورتحساب الکترونیکی و پیگیری وضعیت آن.",
    features: [
      "ارسال صورتحساب الکترونیکی",
      "مدیریت شناسه یکتای حافظه مالیاتی",
      "پیگیری وضعیت و خطاهای ارسال",
      "گزارش صورتحساب‌های ارسالی",
    ],
  },

  // ------------------------------------------------ فروش و مشتری
  {
    id: 18,
    title: "سفارشات",
    module: "PORDR",
    icon: "mdi-clipboard-list-outline",
    description:
      "ثبت و پیگیری سفارشات مشتریان، بررسی موجودی، تأیید مرحله‌ای و اتصال به فروش و انبار.",
    features: [
      "ثبت سفارش مشتری",
      "بررسی موجودی و تخصیص کالا",
      "گردش تأیید سفارش",
      "پیگیری وضعیت تا تحویل",
    ],
  },
  {
    id: 19,
    title: "بازرگانی و فروش",
    module: "PSALE",
    icon: "mdi-sale-outline",
    description:
      "چرخه کامل فروش از پیش‌فاکتور تا فاکتور و برگشت از فروش، به همراه مدیریت مشتریان و گزارش‌های فروش.",
    features: [
      "صدور پیش‌فاکتور و فاکتور فروش",
      "مدیریت مشتریان و قیمت‌گذاری",
      "برگشت از فروش و تخفیفات",
      "گزارش‌های تحلیلی فروش",
    ],
  },
  {
    id: 20,
    title: "خدمات پس از فروش",
    module: "PAFTERSALES",
    icon: "mdi-tools",
    description:
      "ثبت درخواست‌های پشتیبانی و سرویس مشتریان و پیگیری وضعیت آن‌ها.",
    features: ["ثبت و پیگیری پشتیبانی و سرویس‌ها"],
  },
  {
    id: 22,
    title: "سفارشات دانه‌بار",
    module: "PPARAK",
    icon: "mdi-clipboard-list-outline",
    description:
      "ثبت و پیگیری سفارشات دانه‌بار و مدیریت گروه‌بندی کالا و محموله‌های مرتبط با آن.",
    features: [
      "ثبت و پیگیری سفارش دانه‌بار",
      "گروه‌بندی و مدیریت کالا",
      "کنترل وضعیت محموله",
      "گزارش‌های سفارشات",
    ],
  },
  {
    id: 45,
    title: "بازاریابی",
    module: "PMKT",
    icon: "mdi-bullhorn-outline",
    description:
      "مدیریت کمپین‌های بازاریابی، سرنخ‌ها و فرصت‌های فروش از اولین تماس تا تبدیل به مشتری.",
    features: [
      "تعریف و اجرای کمپین بازاریابی",
      "مدیریت سرنخ‌ها و منابع جذب",
      "اولویت‌بندی و پیگیری فرصت فروش",
      "گزارش اثربخشی کمپین‌ها",
    ],
  },

  // ------------------------------------------------ زنجیره تأمین
  {
    id: 23,
    title: "تدارکات و خرید",
    module: "PSCMS",
    icon: "mdi-cart-arrow-down",
    description:
      "از درخواست خرید و استعلام تأمین‌کنندگان تا صدور سفارش خرید و رسید کالا به انبار.",
    features: [
      "ثبت و گردش درخواست خرید",
      "استعلام و مقایسه تأمین‌کنندگان",
      "صدور سفارش خرید",
      "رسید کالا و اتصال به انبار",
    ],
  },
  {
    id: 24,
    title: "انبار و کنترل موجودی",
    module: "PWHRS",
    icon: "mdi-warehouse",
    description:
      "کاردکس کالا، رسید و حواله انبار، انبارگردانی و کنترل موجودی در چند انبار به صورت هم‌زمان.",
    features: [
      "کاردکس و شناسنامه کالا",
      "رسید، حواله و انتقال بین انبارها",
      "انبارگردانی و مغایرت‌گیری",
      "گزارش موجودی و گردش کالا",
    ],
  },
  { id: 25, title: "لجستیک", devKey: "logistics" },

  // ------------------------------------------------ سرمایه انسانی
  { id: 26, title: "جذب و استخدام", devKey: "recruitment" },
  { id: 27, title: "آموزش", devKey: "training" },
  {
    id: 28,
    title: "حقوق و دستمزد",
    module: "PSLRY",
    icon: "mdi-account-cash-outline",
    description:
      "محاسبه حقوق و مزایا بر اساس کارکرد، تولید لیست بیمه و مالیات و صدور فیش حقوقی کارکنان.",
    features: [
      "ثبت کارکرد، اضافه‌کاری و مرخصی",
      "محاسبه حقوق، مزایا و کسورات",
      "تولید لیست بیمه و مالیات",
      "صدور فیش حقوقی و سند حسابداری",
    ],
  },
  { id: 29, title: "سامانه فیش حقوقی", devKey: "payslipPortal" },
  { id: 30, title: "ارزیابی عملکرد و پایش", devKey: "performanceMonitoring" },

  // ------------------------------------------------ عملیات و تولید
  { id: 31, title: "مدیریت پروژه", devKey: "projectManagement" },
  {
    id: 33,
    title: "برنامه‌ریزی تولید آلومینیوم",
    module: "PMRPAL",
    icon: "mdi-factory",
    description:
      "برنامه‌ریزی و کنترل تولید ویژه صنعت آلومینیوم، از تعریف درخت محصول تا پیگیری خطوط تولید.",
    features: [
      "تعریف درخت محصول و مسیر تولید",
      "برنامه‌ریزی سفارش کار",
      "کنترل پیشرفت خطوط تولید",
      "گزارش‌های تولید و ضایعات",
    ],
  },
  {
    id: 34,
    title: "برنامه‌ریزی تولید شیرآلات",
    module: "PMRPVALVS",
    icon: "mdi-pipe-valve",
    description:
      "برنامه‌ریزی و کنترل تولید ویژه صنعت شیرآلات با ساختار محصول و مراحل ساخت اختصاصی.",
    features: [
      "تعریف ساختار محصول شیرآلات",
      "برنامه‌ریزی و صدور سفارش کار",
      "پیگیری مراحل ساخت",
      "گزارش‌های تولید",
    ],
  },
  {
    id: 35,
    title: "بهای تمام شده",
    module: "PMRP",
    icon: "mdi-calculator-variant-outline",
    description:
      "محاسبه بهای تمام شده محصولات بر اساس مواد، دستمزد و سربار و تحلیل انحرافات آن.",
    features: [
      "تجمیع مواد، دستمزد و سربار",
      "محاسبه بهای تمام شده محصول",
      "تحلیل انحراف از استاندارد",
      "گزارش‌های بهای تمام شده",
    ],
  },
  { id: 36, title: "کنترل کیفی", devKey: "qualityManagement" },
  { id: 37, title: "تعمیرات و نگهداری", devKey: "maintenance" },

  // ------------------------------------------------ تکنولوژی و استراتژی
  { id: 38, title: "طراحی و مهندسی", devKey: "engineeringDesign" },
  { id: 39, title: "مدیریت دانش", devKey: "knowledgeManagement" },
  { id: 40, title: "مدیریت فرآیندهای تجاری", devKey: "bpms" },
  { id: 41, title: "هوش تجاری", devKey: "bi" },
  { id: 42, title: "مدیریت روابط عمومی", devKey: "publicRelations" },

  // ------------------------------------------------ فروش فروشگاهی
  {
    id: 47,
    title: "فروشگاهی",
    module: "PSTORE",
    icon: "mdi-storefront-outline",
    description:
      "تعریف فروشگاه‌ها و کاربران پشت صندوق، مقادیر پیش‌فرض فروش و تنظیمات فروش فروشگاهی.",
    features: [
      "تعریف فروشگاه و کاربران صندوق",
      "پیش‌فرض‌های نوع فروش، تسویه و قیمت‌گذاری",
      "چارت مسئولین فروش و کمیسیون پلکانی",
      "تنظیمات فروشگاهی",
    ],
  },
  {
    id: 48,
    title: "غرفه",
    icon: "mdi-view-grid-outline",
    description:
      "تعریف غرفه‌های داخل فروشگاه، گروه‌های کالای هر غرفه و ثبت پیش فاکتور غرفه برای تسویه در صندوق فروشگاه.",
    features: [
      "تعریف غرفه و گروه‌های کالای آن",
      "پیش فاکتور غرفه",
      "تجمیع پیش فاکتورها در صندوق فروشگاه",
      "تنظیمات غرفه",
    ],
  },

  // ------------------------------------------------ سایر
  {
    id: 43,
    title: "همساز",
    module: "PHAMSAZ",
    icon: "mdi-clipboard-text-outline",
    description:
      "مدیریت پروژه‌های پیمانکاری شامل تعریف نوع پروژه، شرح کارها، برآورد و موضوعات جرائم و پاداش.",
    features: [
      "تعریف نوع پروژه و شرح کار",
      "برآورد کلی پروژه",
      "موضوعات جرائم و پاداش",
      "تنظیمات و واحدهای اندازه‌گیری",
    ],
  },
  {
    id: 44,
    title: "همیار",
    module: "PHAMYAR",
    icon: "mdi-target",
    description:
      "مدیریت اهداف سازمانی و وظایف کارکنان، زمان‌بندی اهداف و ثبت یادداشت‌ها و پیگیری‌ها.",
    features: [
      "تعریف و تخصیص اهداف",
      "زمان‌بندی و پیگیری اهداف",
      "دسته‌بندی وظایف و یادداشت‌ها",
      "پایش پیشرفت کارکنان",
    ],
  },
];

// ---------------------------------------------------------------- توابع کمکی

// شناسه زیرسیستم «غرفه» (SubSystemEnum.Booth)؛ جدا از فروشگاهی خریداری می‌شود.
// منوها و صفحه‌های غرفه (غرفه‌ها، پیش فاکتور غرفه، تنظیمات غرفه) فقط با فعال
// بودن آن دیده می‌شوند؛ مسیرهایشان با meta.subSystemId در گارد روتر قفل می‌شوند.
export const BOOTH_SUBSYSTEM_ID = 48;

// حذف آیتم‌های منو که زیرسیستمشان (subSystemId) برای شرکت فعال نیست.
// آرایه ورودی (فایل navbars) دست نمی‌خورد و نسخه جدید برمی‌گردد.
export function filterNavBySubSystems(items, ownedIds) {
  const owned = ownedIds || [];
  const walk = (list) =>
    (list || [])
      .filter(
        (item) =>
          !item ||
          item.subSystemId === null ||
          item.subSystemId === undefined ||
          owned.indexOf(item.subSystemId) !== -1,
      )
      .map((item) =>
        item && Array.isArray(item.subItems) && item.subItems.length > 0
          ? { ...item, subItems: walk(item.subItems) }
          : item,
      );
  return walk(items);
}

// اطلاعات نمایشی زیرسیستم؛ برای ماژول‌های در حال توسعه از config آن‌ها خوانده می‌شود
export function subSystemInfo(item) {
  if (!item) return null;
  const dev = item.devKey ? findUnderDevelopmentModule(item.devKey) : null;
  return {
    id: item.id,
    title: item.title || (dev && dev.title) || "",
    icon: item.icon || (dev && dev.icon) || "mdi-view-grid-outline",
    description: item.description || (dev && dev.description) || "",
    features: item.features || (dev && dev.features) || [],
    group: (dev && dev.group) || null,
  };
}

export function findSubSystemById(id) {
  if (id === null || id === undefined) return null;
  return subSystems.find((i) => i.id === Number(id)) || null;
}

// یافتن زیرسیستم از روی نام مسیر روتر
// نام‌های پشتیبانی‌شده: "PWHRS" | "PWHRSDashboard" | "DEV_pettyCash"
export function findSubSystemByRouteName(routeName) {
  if (!routeName) return null;

  const bare =
    routeName.length > 9 && routeName.slice(-9) === "Dashboard"
      ? routeName.slice(0, -9)
      : routeName;
  if (neverLockedModules.indexOf(bare) !== -1) return null;

  const byModule = subSystems.find((i) => i.module === routeName);
  if (byModule) return byModule;

  if (routeName.indexOf("DEV_") === 0) {
    const key = routeName.slice(4);
    return subSystems.find((i) => i.devKey === key) || null;
  }

  // نام‌های مسیر ماژول‌های در حال توسعه (مثل DEV_pbdgt) که در منوی ماژول‌ها استفاده می‌شوند
  const devMatch = subSystems.find(
    (i) => i.devKey && devRouteName(findUnderDevelopmentModule(i.devKey)) === routeName,
  );
  if (devMatch) return devMatch;

  if (routeName.length > 9 && routeName.slice(-9) === "Dashboard") {
    const prefix = routeName.slice(0, -9);
    return subSystems.find((i) => i.module === prefix) || null;
  }

  return null;
}

// یافتن زیرسیستم مربوط به یک مسیر (route object) در گارد روتر
export function findSubSystemByRoute(route) {
  if (!route) return null;

  // ماژول‌های در حال توسعه کلیدشان در meta ذخیره شده است
  const devKey = route.meta && route.meta.underDevelopment;
  if (devKey) {
    const byDev = subSystems.find((i) => i.devKey === devKey);
    if (byDev) return byDev;
  }

  const matched = route.matched || [];

  // صفحه‌هایی که زیرسیستم جدا از ماژول خود دارند (مثل صفحه‌های غرفه در ماژول
  // فروشگاهی) شناسه را در meta.subSystemId دارند؛ دقیق‌ترین مسیر اولویت دارد.
  for (let i = matched.length - 1; i >= 0; i--) {
    const id = matched[i].meta && matched[i].meta.subSystemId;
    if (id) {
      const byMeta = findSubSystemById(id);
      if (byMeta) return byMeta;
    }
  }

  for (let i = 0; i < matched.length; i++) {
    const name = matched[i].name;
    if (!name || neverLockedModules.indexOf(name) !== -1) continue;
    const found = subSystems.find((s) => s.module === name);
    if (found) return found;
  }

  return null;
}

export default subSystems;
